import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {CreaProfiloComponent} from './crea-profilo';

// @ngInject
const stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.crea-profilo', {
      url: '/crea-profilo/:limit',
      ncyBreadcrumb: {
        label: 'crea-profilo',
        parent: 'home.gestione-listino'
      },
      params: {
        limit: ''
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'crea-profilo'
      },
      views: {
        homeContent: {
          template: '<crea-profilo flex="100"></crea-profilo>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const CreaProfiloModule: string = ng
  .module('crea-profilo', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('creaProfilo', CreaProfiloComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-listino/crea-profilo/crea-profilo.module.ts